import { PromocodePasswordEditorDictionary } from 'types/i18n';

export const promocodePasswordEditorDictionaryRu: PromocodePasswordEditorDictionary = {
  titleText: 'Пароль для сайта',
  passwordLabelText: 'Пароль',
  submitActionText: 'Сохранить изменения',
  cancelActionText: 'Отмена',
};
